import { DateInputLocalized } from '@components'

import { useTranslation } from 'react-i18next'

import { useRecurringInvoiceForm } from '../../../../../../../../contexts/recurringInvoiceFormContext'
import { useUpdateDependentDates } from '../../../../../../../../hooks/useUpdateDependentDates'

export const FirstInvoiceDate = () => {
  const { t } = useTranslation()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()
  const { handleRecurringInvoiceFirstInvoiceDateChange } = useUpdateDependentDates()

  const { FormItem } = recurringInvoiceForm
  const today = new Date()

  return (
    <FormItem
      name="firstInvoiceDate"
      label={t('external_invoices.editor.form.recurring_invoice_settings.field.first_invoice_date.label')}
      render={({ field: { onChange, ...props } }) => (
        <DateInputLocalized
          {...props}
          minDate={today}
          onChange={(date) => {
            handleRecurringInvoiceFirstInvoiceDateChange(date)
            onChange(date)
          }}
          size="sm"
        />
      )}
    />
  )
}
